import { Injectable, Inject, HostListener } from '@angular/core';
import { WINDOW } from '../window/window.service';
import { DOCUMENT } from '@angular/common';
import { BehaviorSubject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class FooterService {

  private showSlaask = new BehaviorSubject<any>({});
  ss = this.showSlaask.asObservable();

  private showFooter = new BehaviorSubject<any>(true);
  sf = this.showFooter.asObservable();

  constructor() { }

  isSlaaskEnabled(b) {
    this.showSlaask.next(b);
  }

  footerVisibility(b) {
    this.showFooter.next(b);
  }
}
